import { NgModule } from '@angular/core';
import { NotificationService } from './services/notification.service';

@NgModule({
  providers: [NotificationService],
})
export class NotificationModule {}
